// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"c7138dce","59":"c7138dce","70":"c7138dce","234":"c7138dce","243":"c7138dce","548":"c7138dce","597":"c7138dce","664":"1a308dca","824":"c7138dce","901":"c7138dce"}[chunkId] + ".chunk.css";
};